import React, { Component } from 'react';


const AppLoad = (props) => {
  return (
    <div className="App AppLoad">
      <div className="spinner--wv-star">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>
    </div>
  );
};


export default AppLoad;
